export default __webpack_public_path__ + "static/media/facebook.fac9075f.svg";